import React from 'react'
import Pt from 'prop-types'
import { Label } from 'react-bootstrap'

import './StateDescription.css'
import {SignupWithExternalsRecord} from "internal-components/src/records";

export default function StateDescription({ state }) {
  switch (state) {
    case 'new':
      return <div className="state-description">
        <Label bsStyle="warning">Incomplete</Label>
        <p><small className="text-muted">Your signup has not yet been submitted to Infinite Networks. Complete all required information and submit the signup to continue.</small></p>
      </div>

    case 'submitted':
      return <div className="state-description">
        <Label bsStyle="success">Submitted</Label>
        <p><small className="text-muted">Your signup has been submitted to Infinite Networks. We are currently qualifying your signup for service quality and availability and we will update you when we have additional information.</small></p>
      </div>

    case 'qualifying':
      return <div className="state-description">
        <Label bsStyle="success">Qualification Complete</Label>
        <p><small className="text-muted">We have finished qualifying your service at the address you supplied.</small></p>
      </div>

    case 'paid':
      return <div className="state-description">
        <Label bsStyle="success">Paid</Label>
        <p><small className="text-muted">Your signup has been accepted and a payment has been taken from your nominated credit card. We have placed an order with an upstream supplier for your signup.</small></p>
      </div>

    case 'ordered':
      return <div className="state-description">
        <Label bsStyle="success">Ordered</Label>
        <p><small className="text-muted">We have placed an order with an upstream supplier for your signup.</small></p>
      </div>

    case 'pending-install':
      return <div className="state-description">
        <Label bsStyle="success">Pending Install</Label>
        <p><small className="text-muted">Our upstream supplier has provided us with an installation date for your signup.</small></p>
      </div>

    case 'installed':
      return <div className="state-description">
        <Label bsStyle="success">Installed</Label>
        <p><small className="text-muted">Your service is installed, however we are waiting for additional works to be completed before the service can be activated.</small></p>
      </div>

    case 'active':
      return <div className="state-description">
        <Label bsStyle="info">Active</Label>
        <p><small className="text-muted">Your service is now active. You will have received an email from us with any information required to use your service.</small></p>
      </div>

    case 'cancelled':
      return <div className="state-description">
        <Label bsStyle="info">Cancelled</Label>
        <p><small className="text-muted">This signup has been cancelled.</small></p>
      </div>

    case 'needs-info':
      return <div className="state-description">
        <Label bsStyle="warning">Needs Info</Label>
        <p><small className="text-muted">We dont have enough information to complete this signup and will contact you to request additional information.</small></p>
      </div>

    case 'rejected':
      return <div className="state-description">
        <Label bsStyle="info">Rejected</Label>
        <p><small className="text-muted">We are unable to provide this service to you.</small></p>
      </div>

    case 'fault':
      return <div className="state-description">
        <Label bsStyle="danger">Fault</Label>
        <p><small className="text-muted">There has been a problem while provisioning your service and we are awaiting resolution.</small></p>
      </div>

    case 'auto-process':
      return <div className="state-description">
        <Label bsStyle="success">Processing</Label>
        <p><small className="text-muted">Your signup is being processed by our automated systems.</small></p>
      </div>

    default:
      return <div className="state-description">
        <Label bsStyle="success">{state}</Label>
      </div>
  }
}

StateDescription.propTypes = {
  state: Pt.string.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/SignupDetails/StateDescription.jsx